<template>
    <div :class="[$style['filter-calc'], 'j-filter-calc']">
        <div :class="[$style['filter-calc__content'], 'j-filter-calc-content']">
            <form action="/" method="post" :class="$style['filter-calc__form', 'j-mbox-mortgage']">
                <div :class="$style['filter-calc__form-input']">
                    <div :class="$style['filter-calc__form-input-label']">Тип ипотеки</div>
                    <SingleSelect :filter="filter"
                                  :select="tabs"
                                  :slug="tabs.name"
                                  label="Тип ипотеки"
                                  @change="changeTab"/>
                </div>

                <div v-if="filter.sliders.price && !filter.sliders.price.hide"
                     :class="$style['filter-calc__form-input']">
                    <RangeSlider :slider="filter.sliders.price"
                                 :isChanged="isPriceChanged"
                                 slug="price"
                                 ref="price"
                                 @change="changeSlider"
                                 @change-end="endChangeSlider"/>
                </div>

                <div v-if="filter.sliders.pay && !filter.sliders.pay.hide"
                     :class="$style['filter-calc__form-input']">
                    <RangeSlider :slider="filter.sliders.pay"
                                 :isChanged="isPayChanged"
                                 slug="pay"
                                 ref="pay"
                                 @change="changeSlider"
                                 @change-end="endChangeSlider"/>
                </div>

                <div v-if="filter.sliders.term && !filter.sliders.term.hide"
                     :class="$style['filter-calc__form-input']">
                    <RangeSlider :slider="filter.sliders.term"
                                 :isChanged="isTermChanged"
                                 slug="term"
                                 ref="term"
                                 @change="changeSlider"
                                 @change-end="endChangeSlider"/>
                </div>

                <div :class="[$style['filter-calc__form-input'], $style['filter-calc__form-input-table']]">
                    <Button modify="white" v-scroll-to="'#mortgage-calc-top'">Посмотреть условия банков</Button>
                </div>

                <div :class="$style['filter-calc__bottom']">
                    {{ filter.description }}
                </div>

                <div :class="$style['filter-calc__consultation']">
                    <!-- <div :class="$style['filter-calc__consultation-img']">
                        <div>
                            <img src="/images/calculator/consultation.jpg" alt="Консультация по ипотеке">
                        </div>
                    </div> -->
                    <h4 :class="$style['filter-calc__consultation-title']">Консультация по ипотеке</h4>
                    <p>Оставьте заявку, и мы подберем для вас наиболее подходящий вариант.</p>
                </div>

                <div :class="$style['filter-calc__form-input']">
                    <Button @click="mortgagePopupOpen">Подать заявку на ипотеку</Button>

                    <Popup ref="popup"
                           :isSuccess="isFormSuccess"
                           :isError="isFormError"
                           @popupClose="setFormInit">
                        <Order :personLink="personLink"
                               :sendData="sendData"
                               :isSuccess="isFormSuccess"
                               :isError="isFormError"
                               @formSuccess="setFormSendSuccess"
                               @formError="setFormSendError" />
                    </Popup>
                </div>
            </form>

        </div>

    </div>
</template>

<script>
    import Button from '../Button/Button';
    import MultiSelect from '../forms/MultiSelect/MultiSelect';
    import Order from '../Order/Order';
    import Popup from '../Popup/Popup';
    import RangeSlider from '../forms/RangeSlider/RangeSlider';
    import SingleSelect from '../forms/SingleSelect/SingleSelect';

    export default {
        components: {
            Button,
            MultiSelect,
            Order,
            Popup,
            RangeSlider,
            SingleSelect
        },

        props: ['filter', 'tabs', 'personLink', 'sendData', 'isPriceChanged', 'isPayChanged', 'isTermChanged', 'update'],

        data: () => ({
            isPayChange: false,
            isFormError: false,
            isFormSuccess: false,
            errors: {
                complex: '',
                building: '',
                range: ''
            }
        }),

        created() {
            this.isPayChange = this.isPayChanged;
        },

        methods: {
            changeSlider(slug) {
                if (slug === 'price') {
                    this.changePrice();
                }

                if (slug === 'pay') {
                    this.changePay();
                }

                if (slug === 'pay' || slug === 'price') {
                    this.setPayPercent();
                }

                if (slug === 'term') {
                    this.changeTerm();
                }
            },

            endChangeSlider(slug) {
                this.changeSlider(slug);
                this.sendEmit();
            },

            changeTerm() {
                this.isTermChange = true;
                this.$emit('changeTerm');
            },

            changePay() {
                this.isPayChange = true;
                this.checkRangePay();
                this.$emit('changePay');
            },

            /**
             * Входит ли Первый взнос в процентные рамки от цены.
             */
            checkRangePay() {
                const price = this.filter.sliders.price;
                const pay = this.filter.sliders.pay;
                const percent = Number((pay.value / price.value * 100).toFixed());
                let min = Math.round(price.value * (this.filter.minPayPercent /100));
                let max = Math.round(price.value * (this.filter.maxPayPercent /100));
                min = min % pay.interval ? min - min % pay.interval : min;
                max = max % pay.interval ? (max - max % pay.interval) + pay.interval : max;

                this.errors.range = '';

                if (pay.value < min || percent < this.filter.minPayPercent) {
                    this.errors.range = 'smallPay';
                } else if (pay.value > max) {
                    if (percent > this.filter.maxPayPercent && percent <= 100) {
                        this.errors.range = 'base';
                    } else {
                        this.errors.range = 'largePay';
                    }
                } else if (percent > this.filter.maxPayPercent && percent <= 100) {
                    this.errors.range = 'base';
                }
            },

            changePrice() {
                const price = this.filter.sliders.price;
                const pay = this.filter.sliders.pay;
                let min = Math.round(price.value * (this.filter.minPayPercent / 100));
                let max = Math.round(price.value * (this.filter.maxPayPercent / 100));
                this.errors.range = '';

                this.$emit('changePrice');

                if (!this.isPayChange) {
                    setMin();
                    setMax();
                    pay.value = price.value * (this.filter.defPayPercent / 100);
                } else {
                    if (pay.value + pay.interval < min) {
                        setMax();
                        pay.min = pay.value;
                        this.errors.range = 'smallPay';
                    } else if (pay.value - pay.interval > max) {
                        setMin();
                        pay.max = pay.value;
                        this.errors.range = 'largePay';
                    } else {
                        setMax();
                        setMin();
                    }
                }

                function setMin() {
                    pay.min = min % pay.interval ? min - min % pay.interval : min;
                }

                function setMax() {
                    pay.max = max % pay.interval ? (max - max % pay.interval) + pay.interval : max;
                }
            },

            /**
             * Проверяет подходит ли жк под цену ()
             */
            checkPriceComplex() {
                const price = Number(this.filter.sliders.price.value);
                const complex = this.filter.selects.complex;

                if (!complex) {
                    return;
                }

                complex.options.forEach((option) => {
                    if (option.hasOwnProperty('pass')) {
                        const roundCoef = 50000;
                        const roundMin = Math.round(Math.floor(option.min/roundCoef))*roundCoef;
                        const roundMax = Math.round(Math.ceil(option.max/roundCoef))*roundCoef;
                        option.pass = price.between(roundMin, roundMax);

                        if (option.selected) {
                            this.errors.complex = option.pass ? '' : 'base';
                        }
                    }
                });
            },

            /**
             * Проверяет подходит ли жк под цену ()
             */
            checkPriceBuilding() {
                if (!this.building) {
                    return;
                }

                const buildingSelected = this.building.options.filter(option => option.selected);
                const buildingNoPass = buildingSelected.filter(option => !option.pass);
                this.errors.building = '';

                if (buildingSelected.length && buildingSelected.length <= buildingNoPass.length) {
                    this.errors.building = 'base';
                }
            },

            /**
             * Подсчитывает процент первого взноса от цены
             */
            setPayPercent() {
                const pay = this.filter.sliders.pay;
                const price = this.filter.sliders.price;

                if (!price || !pay) {
                    return;
                }

                const percent = (pay.value / price.value * 100).toFixed();

                pay.valueCaption = `${percent}%`;
            },

            changeComplex(name, option) {
                this.errors.building = '';

                if (this.building) {
                    this.building.options.forEach((building) => {
                        building.selected = false;
                    });
                }

                this.errors.complex = option.pass === false ? 'base' : '';
                this.sendEmit();
            },

            changeBuilding(name, options) {
                let pass = false;

                options.forEach((option) => {
                    option.pass ? pass = true : '';
                });

                if (!options.length) {
                    pass = true;
                }

                this.errors.building = pass ? '' : 'base';

                this.sendEmit();
            },

            /**
             * Ставит жк по дефоту
             */
            setDefaultValueComplex() {
                this.filter.selects.complex.options.forEach((option, key) => {
                    option.selected = key === 0;
                });
            },

            /**
             * Возращает выбранный жк
             */
            getActiveComplex() {
                if (this.filter.selects.complex) {
                    return this.filter.selects.complex.options.find(option => option.selected);
                }

                return false;
            },

            sendEmit() {
                let send = true;

                for (const key in this.errors) {
                    if (this.errors.hasOwnProperty(key)) {
                        if (this.errors[key]) {
                            if (this.errors[key] === 'largePay' || this.errors[key] === 'smallPay') {
                                this.$emit('toUpdate', false);
                            }
                            this.$emit('noResult', this.errors[key]);
                        } else {
                            this.$emit('toUpdate', true);
                        }
                    }
                }

                if (send) {
                    this.$emit('change');
                } else {
                    this.$emit('safeHistory');
                }
            },

            changeTab(val, object) {
                this.$emit('changeTab', object);
                this.$emit('toUpdate', true);
            },

            popupOpen() {
                this.$refs.popup.open();
            },

            mortgagePopupOpen() {
                this.popupOpen();
                this.setCommonDataLayerOpen();
            },

            resetFilter() {
                this.$refs.price.changed = false;
                this.$refs.pay.changed = false;
                this.$refs.term.changed = false;
                this.isPayChange = false;
                this.$emit('toUpdate', true);
            },

            getBuilding() {
                return this.building;
            },

            clearErrors() {
                this.errors = {
                    complex: '',
                    building: '',
                    range: ''
                }
            },

            setFormSendError() {
                this.isFormSuccess = false;
                this.isFormError = true;
            },

            setFormSendSuccess() {
                this.isFormSuccess = true;
                this.isFormError = false;
                this.setCommonDataLayerSend();
            },

            setFormInit() {
                this.isFormSuccess = false;
                this.isFormError = false;
            },

            setCommonDataLayerOpen() {
                window.dataLayer = window.dataLayer || [];

                window.dataLayer.push({
                    event     : 'GAevent',
                    GAcategory: 'form',
                    GAaction  : 'open',
                    GAlabel   : 'mortgageapply'
                });

                if (this.$dataset && this.$dataset.flatId) {
                    const price = this.filter && this.filter.sliders && this.filter.sliders.price &&
                        this.filter.sliders.price.value || 0;

                    window.dataLayer.push({
                        event: 'AddToCart',
                        products: [{
                            id: this.$dataset.flatId,
                            price: price.toString()
                        }]
                    });
                }
            },

            setCommonDataLayerSend() {
                window.dataLayer = window.dataLayer || [];

                window.dataLayer.push({
                    event     : 'GAevent',
                    GAcategory: 'form',
                    GAaction  : 'send',
                    GAlabel   : 'mortgageapply'
                });

                if (this.$dataset && this.$dataset.flatId) {
                    const price = this.filter && this.filter.sliders && this.filter.sliders.price &&
                        this.filter.sliders.price.value || 0;

                    window.dataLayer.push({
                        event: 'Purchase',
                        products: [{
                            id: this.$dataset.flatId,
                            price: price.toString()
                        }]
                    });
                }
            }
        }
    }
</script>

<style lang="scss" module>
    @import "./FilterCalc";
</style>
